import classNames from "classnames";
import styles from "./AccountNotFound.module.css";

const strings = {
  noAccountFound: "No account matches the provided search.\nPlease try again.",
};

type Props = {
  className?: string;
  titleClassName?: string;
};
function AccountNotFound({ className, titleClassName }: Props) {
  return (
    <div className={classNames(styles.container, className)}>
      <h2 className={classNames(styles.noAccountFound, titleClassName)}>
        {strings.noAccountFound}
      </h2>
    </div>
  );
}
export default AccountNotFound;
